// Shared analysis routes keep the mounted chart. Only new-only pages need a
// legacy destination; remember that pair so returning restores the native view.
export function versionDestination(renewed, route, returnPair) {
  if (!renewed && ['new', 'insight'].includes(route.name)) {
    const legacy = route.name === 'new' ? '/' : route.query.tab === 'economy' ? '/economy' : '/realestate';
    return { path: legacy, returnPair: { legacy, renewed: route.fullPath } };
  }
  if (renewed && returnPair && route.fullPath === returnPair.legacy) {
    return { path: returnPair.renewed, returnPair: null };
  }
  if (renewed && route.name === 'legacy') return { path: '/new', returnPair: null };
  return { path: null, returnPair: null };
}
